export default "__VITE_ASSET__edd33936__"